import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples 
*/
import { NzIconModule } from 'ng-zorro-antd/icon';


//Routing Module for the specific View Module
import { RegistrationRoutingModule } from './registration-routing.module'
import { SearchRegistrationComponent } from './search-registration/search-registration.component';


//Shared Module
import { SharedComponentsModule } from '../../shared-components/shared-components.module'
import { SharedServicesModule } from '../../shared-services/shared-services.module'

//Should be added for Translations to be loaded on Lazy Loads
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiLingualService } from 'app/BaseFramework/core/services'
import { NgZorroAntdModule } from 'app/ng-zorro.module';

@NgModule({
  imports: [
    CommonModule,
    NgZorroAntdModule,
    NzIconModule,
    SharedComponentsModule,
    SharedServicesModule,
    RegistrationRoutingModule
  ],
  declarations: [SearchRegistrationComponent],
  exports: [SearchRegistrationComponent]
})
export class RegistrationModule {
  //Should be added for Translations to be loaded on Lazy Loads
  constructor(private translateService: TranslateService,
    private multiLingualService:MultiLingualService) {
    this.multiLingualService.resetLanguageLocales(this.translateService)
  }
}
